import styled from 'styled-components';
export var handleTarget = function handleTarget(_ref) {
  var target = _ref.target;
  return {
    rel: target === '_blank' ? 'noopener' : undefined
  };
};
var Link = /*#__PURE__*/styled.a.attrs(handleTarget).withConfig({
  displayName: "Link",
  componentId: "sc-1lrm05w-0"
})(["color:", ";font-family:", ";font-weight:", ";font-size:", ";text-decoration:none;cursor:pointer;&:hover{text-decoration:underline;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.link.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.fontWeight.normal;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fonts.fontSize.ft16;
});
Link.displayName = 'Link';
export default Link;